<script>
  import { onMount } from 'svelte';
  import { getApiUrl } from '../api';
  import { authFetch } from '../authService';

  let plans = [];
  let isLoading = true;
  let error = '';
  
  // Form State
  let isEditing = false;
  let currentId = null;
  let form = {
      name: '', currency: 'HKD', amount: 0, 
      billingFrequency: 'Monthly', discountDesc: '', 
      freeCredits: 0, creditsOnPlan: 0, freeMonths: 0,
      countryCode: 'HK'
  };

  onMount(fetchPlans);

  async function fetchPlans() {
      isLoading = true;
      try {
          const res = await authFetch(getApiUrl('/admin/business-plans'));
          plans = await res.json();
      } catch(e) { error = e.message; }
      isLoading = false;
  }

  function resetForm() {
      form = { name: '', currency: 'HKD', amount: 0, billingFrequency: 'Monthly', discountDesc: '', freeCredits: 0, creditsOnPlan: 0, freeMonths: 0, countryCode: 'HK' };
      isEditing = false;
      currentId = null;
  }

  function startEdit(plan) {
      form = { ...plan };
      isEditing = true;
      currentId = plan._id;
  }

  async function handleSubmit() {
      const url = isEditing ? `/admin/business-plans/${currentId}` : '/admin/business-plans';
      const method = isEditing ? 'PUT' : 'POST';
      
      await authFetch(getApiUrl(url), {
          method,
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(form)
      });
      
      resetForm();
      fetchPlans();
  }

  async function handleDelete(id) {
      if(!confirm("Delete this plan?")) return;
      await authFetch(getApiUrl(`/admin/business-plans/${id}`), { method: 'DELETE' });
      fetchPlans();
  }
</script>

<div class="container">
    <h2>Business Plan Maintenance</h2>
    
    <div class="form-card">
        <h3>{isEditing ? 'Edit Plan' : 'Add New Plan'}</h3>
        <form on:submit|preventDefault={handleSubmit}>
            <div class="row">
                <div class="group"><label>Name</label><input type="text" bind:value={form.name} required /></div>
                <div class="group"><label>Country</label><input type="text" bind:value={form.countryCode} required /></div>
            </div>
            <div class="row">
                <div class="group"><label>Frequency</label>
                    <select bind:value={form.billingFrequency}>
                        <option>Monthly</option>
                        <option>Annually</option>
                    </select>
                </div>
                <div class="group"><label>Currency</label><input type="text" bind:value={form.currency} /></div>
                <div class="group"><label>Amount</label><input type="number" step="0.01" bind:value={form.amount} /></div>
            </div>
            <div class="row">
                <div class="group"><label>Credits (Recurring)</label><input type="number" bind:value={form.creditsOnPlan} /></div>
                <div class="group"><label>Free Credits (One-time)</label><input type="number" bind:value={form.freeCredits} /></div>
                <div class="group"><label>Free Months</label><input type="number" bind:value={form.freeMonths} /></div>
            </div>
            <div class="group"><label>Discount Description</label><input type="text" bind:value={form.discountDesc} /></div>
            
            <div class="actions">
                <button type="button" on:click={resetForm} class="secondary">Cancel</button>
                <button type="submit" class="primary">Save Plan</button>
            </div>
        </form>
    </div>

    <div class="list">
        <table>
            <thead><tr><th>Name</th><th>Country</th><th>Freq</th><th>Price</th><th>Credits</th><th>Actions</th></tr></thead>
            <tbody>
                {#each plans as p}
                    <tr>
                        <td>{p.name}</td>
                        <td>{p.countryCode}</td>
                        <td>{p.billingFrequency}</td>
                        <td>{p.currency} {p.amount}</td>
                        <td>{p.creditsOnPlan} (+{p.freeCredits} free)</td>
                        <td>
                            <button on:click={() => startEdit(p)}>✏️</button>
                            <button on:click={() => handleDelete(p._id)}>🗑️</button>
                        </td>
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
</div>

<style>
    .container { max-width: 900px; margin: 2rem auto; padding: 1rem; }
    .form-card { background: white; padding: 1.5rem; border-radius: 8px; box-shadow: 0 2px 5px rgba(0,0,0,0.1); margin-bottom: 2rem; }
    .row { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 1rem; }
    .group { margin-bottom: 1rem; }
    label { display: block; font-weight: 500; margin-bottom: 0.3rem; font-size: 0.9rem; }
    input, select { width: 100%; padding: 0.5rem; border: 1px solid #ccc; border-radius: 4px; box-sizing: border-box; }
    .actions { display: flex; justify-content: flex-end; gap: 1rem; }
    button { padding: 0.5rem 1rem; cursor: pointer; border: none; border-radius: 4px; }
    .primary { background: #007bff; color: white; }
    .secondary { background: #6c757d; color: white; }
    
    table { width: 100%; border-collapse: collapse; background: white; }
    th, td { padding: 10px; border-bottom: 1px solid #eee; text-align: left; }
    th { background: #f8f9fa; }
</style>